import type { Evento } from '@/types'

export function formatDateRange(evento: Evento) {
  const inicio = new Date(evento.inicio_em)
  const fim = evento.fim_em ? new Date(evento.fim_em) : null

  const formatter = new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: 'long',
    hour: '2-digit',
    minute: '2-digit',
  })

  const fimTexto = fim ? formatter.format(fim) : 'A definir'

  return `${formatter.format(inicio)} até ${fimTexto}`
}
